import Breadcrumb from "components/Common/Breadcrumb"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import useLocationData from "custom hooks/useLocationData"
import { validateContact, validateString } from "helpers/common_helper"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Row, Container, CardBody, Card } from "reactstrap"
import Select from "react-select"
import { customStyles } from "helpers/select-styles"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import { designation_options } from "constants/layout"

const AddStaff = () => {
  // Individual states for each field
  const [firstName, setFirstName] = useState("")
  const [middleName, setMiddleName] = useState("")
  const [lastName, setLastName] = useState("")
  // const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("")
  // const [password, setPassword] = useState("");
  const [contact, setContactNumber] = useState("")
  const [altContact, setAltContactNumber] = useState("")
  const [weekDayHours, setWeekDayHours] = useState("")
  const [weekendHours, setWeekendHours] = useState("")

  const [address1, setAddress1] = useState("")
  const [postcode, setPostcode] = useState("")

  const [role, setRole] = useState("")
  const [rolesOptions, setRolesOptions] = useState([])
  // const [allowNotify, setAllowNotify] = useState("");
  const [designation, setDesignation] = useState([])
  const [empOptions, setEmpOptions] = useState([])

  const [budget, setBudget] = useState("")
  const [budgetOptions, setBudgetOptions] = useState([])
  const [reportees, setReportees] = useState([]);

  const [logo, setLogo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const {
    states,
    cities,
    selectedState,
    selectedCity,
    handleStateChange,
    setSelectedCity,
  } = useLocationData();

  const { checkAccess } = usePermissionData();
  const module_id = 4;


  const getStaff = async () => {
    try {
      const response = await axiosbaseurl.get("/employee-master")
      if (response.data.success) {
        setEmpOptions(response.data.data?.map((emp) => ({ label: `${emp.name || ''} ${emp.lastName || ''}`, value: emp.id })))
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getDatas = async () => {
    try {
      const response = await axiosbaseurl.get(`/roles-and-permission/active`)
      if (response.data.success) {
        setRolesOptions(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBudgets = async () => {
    try {
      const response = await axiosbaseurl.get(`/budget-master`)
      if (response.data.success) {
        setBudgetOptions(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      await getDatas()
      await getStaff()
      await getBudgets()
    })()
  }, [])

  // Validation logic
  const validate = () => {
    let tempErrors = {}
    if (!firstName) tempErrors.firstName = "First Name is required."
    if (!lastName) tempErrors.lastName = "Last Name is required."
    // if (!userName) tempErrors.userName = "User Name is required.";
    if (!contact) tempErrors.contact = "Contact is required."
    if (!altContact) tempErrors.altContact = "Alt contact is required."

    if (!email || !/\S+@\S+\.\S+/.test(email))
      tempErrors.email = "Valid Email is required."
    // if (!password || password?.length < 8) tempErrors.password = "Password with minimum 8 letters required.";
    if (!selectedState) tempErrors.state = "Country is required."
    if (!selectedCity) tempErrors.city = "City is required."
    if (!address1) tempErrors.address1 = "Address is required."
    if (!postcode) tempErrors.postcode = "Postcode is required."
    if (!designation.length) tempErrors.designation = "Designation is required."
    if (!role) tempErrors.role = "Role is required."
    if (!budget) tempErrors.budget = "Budget is required."

    if (!validateTime(weekDayHours)) {
      tempErrors.weekday = "Valid time required! Format: hh:mm, 00:00 - 23:59";
    }

    if (!validateTime(weekendHours)) {
      tempErrors.weekendday = "Valid time required! Format: hh:mm, 00:00 - 23:59";
    }

    // if (!allowNotify) tempErrors.allowNotify = "Allow notifiy is required.";
    // if (!twoFactor) tempErrors.twoFactor = "Two factor is required.";

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  useEffect(() => {
    document.title = "Add Staff | Peacock Accountants Limited"
  }, [])

  const navigate = useNavigate()

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()
    if (validate()) {
      const formData = new FormData()
      formData.append("name", firstName)
      formData.append("middleName", middleName)
      formData.append("lastName", lastName)
      // formData.append("username", userName)
      formData.append("email", email)
      formData.append("contactNumber", contact)
      formData.append("alternateContactNumber", altContact)
      formData.append("weekdayHours", weekDayHours)
      formData.append("weekendHours", weekendHours)
      formData.append("address", address1)
      formData.append("country", selectedState)
      formData.append("city", selectedCity?.value || selectedCity)
      formData.append("postcode", postcode)
      formData.append(
        "designation",
        JSON.stringify(designation.map(i => i.value))
      )
      formData.append("reportees", reportees?.map(r => r.value).toString() || "")

      formData.append("roleId", role)
      formData.append("budgetId", budget)
      // formData.append("allowNotification", allowNotify)
      // formData.append("enableTwoFactor", twoFactor)
      // formData.append("password", password)
      formData.append("profilePhoto", logo)

      try {
        setLoading(true)
        const response = await axiosbaseurl.post("/employee-master", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        if (response.data.message === "Employee created successfully.") {
          swal("", response.data.message, "success")
          navigate(-1)
        }
      } catch (error) {
        console.log(error)
        swal("", error.response.data.message || "Something went Wrong", "error")
      } finally {
        setLoading(false)
      }
    } else window.scrollTo(0, 260)
  }

  // Handle logo upload
  const handleLogoChange = e => {
    const file = e.target.files[0]
    if (file) {
      setLogo(file)
    }
  }


  // Full validation for HH:mm (hours: 00-23, minutes: 00-59)
  const validateTime = (value) => {
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    return regex.test(value);
  };

  const handleChange = (e, setTime, field) => {
    let val = e.target.value;

    // Remove any non-digit and non-colon characters
    val = val.replace(/[^\d:]/g, "");

    // Automatically insert colon after 2 digits (if not already there)
    if (val.length > 2) {
      // Remove all colons first
      val = val.replace(/:/g, "");
      val = val.slice(0, 2) + ":" + val.slice(2, 4);
    }

    // Limit length to 5 chars: HH:mm
    if (val.length > 5) {
      val = val.slice(0, 5);
    }

    setTime(val);

    // Validate when full time entered
    if (val.length === 5) {
      if (!validateTime(val)) {
        setErrors(prev => ({ ...prev, [field]: "Invalid time! Format: HH:mm, 00:00 - 23:59" }))
      } else {
        setErrors(prev => ({ ...prev, [field]: "" }))

      }
    } else {
      setErrors(prev => ({ ...prev, [field]: "" }))

    }
  };


  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Add Employee"} />
          <Card className="">
            <CardBody>
              <PermittedComponent isAccess={checkAccess(module_id, "add")}>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <div>
                        <label>Upload Profile Photo</label>
                        <input
                          type="file"
                          onChange={handleLogoChange}
                          className="form-control input-field"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="ms-4">
                        {logo && (
                          <img
                            src={URL.createObjectURL(logo)}
                            width={80}
                            height={80}
                            style={{ objectFit: "contain" }}
                            alt=""
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-md-4 text-end">
                      <LoadingButton loading={loading} />
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-secondary bg-dark ms-3"
                      >
                        <i className="fas fa-arrow-left me-3"></i>
                        Back
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        placeholder="Enter First Name"
                        onChange={e => setFirstName(e.target.value)}
                        className="form-control input-field"
                        onKeyDown={validateString}
                      />
                      <span className="error">{errors.firstName}</span>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Middle Name </label>
                      <input
                        type="text"
                        value={middleName}
                        placeholder="Enter Middle Name"
                        onChange={e => setMiddleName(e.target.value)}
                        className="form-control input-field"
                        onKeyDown={validateString}
                      />
                      <span className="error">{errors.middleName}</span>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        placeholder="Enter Last Name"
                        onChange={e => setLastName(e.target.value)}
                        className="form-control input-field"
                        onKeyDown={validateString}
                      />
                      <span className="error">{errors.lastName}</span>
                    </div>

                    {/* <div className="col-md-4 mb-3">
                                        <label>Username <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            value={userName}
                                            placeholder='Enter Username'
                                            onChange={(e) => setUserName(e.target.value)}
                                            className="form-control input-field"
                                        />
                                        <span className="error">{errors.userName}</span>
                                    </div> */}

                    <div className="col-md-4 mb-3">
                      <label>
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        placeholder="Enter Email "
                        value={email}
                        onChange={e => setEmail(e.target.value.toLowerCase())}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.email}</span>
                    </div>

                    {/* <div className="col-md-4 mb-3">
                                        <label>Password <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            placeholder='Enter Password '
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-control input-field"
                                        />
                                        <span className="error">{errors.password}</span>
                                    </div> */}

                    <div className="col-md-4 mb-3">
                      <label>
                        Contact Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Contact Number"
                        value={contact}
                        onChange={e => setContactNumber(e.target.value)}
                        className="form-control input-field"
                        onKeyDown={validateContact}
                      />
                      <span className="error">{errors.contact}</span>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>
                        Alternate Contact Number{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Contact Number"
                        value={altContact}
                        onChange={e => setAltContactNumber(e.target.value)}
                        className="form-control input-field"
                        onKeyDown={validateContact}
                      />
                      <span className="error">{errors.altContact}</span>
                    </div>
                  </div>

                  <div className="row align-items-end ">
                    <div className="col-md-4 mb-3">
                      <label>
                        Employee Weekday Working Hours (hh:mm) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="hh:mm"
                        maxLength={5}
                        value={weekDayHours}
                        onChange={e => handleChange(e, setWeekDayHours, "weekday")}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.weekday}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Employee Weekendday Working Hours (hh:mm) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="hh:mm"
                        maxLength={5}
                        value={weekendHours}
                        onChange={e => handleChange(e, setWeekendHours, "weekendday")}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.weekendday}</span>
                    </div>
                  </div>

                  <div className="row align-items-end mt-3">
                    <div className="col-md-4 mb-3">
                      <label>
                        Country <span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={e => handleStateChange(e.target.value)}
                        value={selectedState}
                        className="form-select input-field status_select_dropdown"
                      >
                        <option value="">Select Country</option>
                        {states.map(state => {
                          return (
                            <option key={state.isoCode} value={state.isoCode}>
                              {state.name}
                            </option>
                          )
                        })}
                        <option value="Non-UK">Non-UK</option>
                      </select>
                      <span className="error">{errors.state}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        City <span className="text-danger">*</span>
                      </label>
                      {selectedState == "Non-UK" ? (
                        <input
                          type="text"
                          placeholder="Enter City"
                          value={selectedCity}
                          onChange={e => setSelectedCity(e.target.value)}
                          className="form-control input-field"
                        />
                      ) : (
                        <Select
                          value={selectedCity}
                          onChange={e => setSelectedCity(e)}
                          options={cities}
                          styles={customStyles}
                          placeholder={"Select City"}
                        />
                      )}

                      <span className="error">{errors.city}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Address "
                        value={address1}
                        onChange={e => setAddress1(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.address1}</span>
                    </div>

                    {/* 
                                    <div className="col-md-4 mb-3">
                                        <label>Address 2</label>
                                        <input
                                            type="text"
                                            placeholder='Enter Address 2 '
                                            value={address2}
                                            onChange={(e) => setAddress2(e.target.value)}
                                            className="form-control input-field"
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label>Address 3</label>
                                        <input
                                            type="text"
                                            placeholder='Enter Address 3 '
                                            value={address3}
                                            onChange={(e) => setAddress3(e.target.value)}
                                            className="form-control input-field"
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label>Address 4</label>
                                        <input
                                            type="text"
                                            placeholder='Enter Address 4 '
                                            value={address4}
                                            onChange={(e) => setAddress4(e.target.value)}
                                            className="form-control input-field"
                                        />
                                    </div> */}

                    <div className="col-md-4 mb-3">
                      <label>
                        Postcode <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Postcode "
                        value={postcode}
                        onChange={e => setPostcode(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.postcode}</span>
                    </div>
                  </div>

                  <div className="row align-items-end mt-3">
                    <div className="col-md-4 mb-3">
                      <label>
                        Designation <span className="text-danger">*</span>
                      </label>
                      <Select
                        value={designation}
                        onChange={e => setDesignation(e)}
                        options={designation_options}
                        styles={customStyles}
                        isMulti
                      />
                      <span className="error">{errors.designation}</span>
                      {/* <select
                                            value={designation}
                                            onChange={(e) => setDesignation(e.target.value)}
                                            className="form-select input-field status_select_dropdown"
                                        >
                                            <option value="">Select Designation</option>
                                            <option value="Client Manager">Client Manager</option>
                                            <option value="Production Manager">Production Manager</option>
                                            <option value="Assistant">Assistant</option>
                                            <option value="Administrator">Administrator</option>
                                        </select> */}
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>
                        Role <span className="text-danger">*</span>
                      </label>
                      <select
                        value={role}
                        onChange={e => setRole(e.target.value)}
                        className="form-select input-field status_select_dropdown"
                      >
                        <option value="">Select Role</option>
                        {rolesOptions
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map(item => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                      <span className="error">{errors.role}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Reportees
                      </label>
                      <Select
                        value={reportees}
                        onChange={e => setReportees(e)}
                        options={empOptions}
                        styles={customStyles}
                        isMulti
                      />
                      <span className="error">{errors.designation}</span>
                    </div>

                    {/* <div className="col-md-2 mb-3">
                                        <label>Allow Notification <span className='text-danger'>*</span></label>
                                        <select
                                            value={allowNotify}
                                            onChange={(e) => setAllowNotify(e.target.value)}
                                            className="form-select input-field status_select_dropdown"
                                        >
                                            <option value="">Select </option>
                                            <option value={"true"}>Yes</option>
                                            <option value={"false"}>No</option>
                                        </select>
                                        <span className="error">{errors.allowNotify}</span>
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label>Enable Two Factor <span className='text-danger'>*</span></label>
                                        <select
                                            value={twoFactor}
                                            onChange={(e) => setTwoFactor(e.target.value)}
                                            className="form-select input-field status_select_dropdown"
                                        >
                                            <option value="">Select </option>
                                            <option value={"true"}>Yes</option>
                                            <option value={"false"}>No</option>
                                        </select>
                                        <span className="error">{errors.twoFactor}</span>
                                    </div> */}

                    <div className="col-md-4 mb-3">
                      <label>
                        Budget <span className="text-danger">*</span>
                      </label>
                      <select
                        value={budget}
                        onChange={e => setBudget(e.target.value)}
                        className="form-select input-field status_select_dropdown" >
                        <option value="">Select Budget</option>
                        {budgetOptions
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map(item => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                      <span className="error">{errors.budget}</span>
                    </div>
                  </div>
                </form>
              </PermittedComponent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  )
}

export default AddStaff
